import { remove } from 'aws-amplify/storage';
import { S3File } from "features/file-browser/state/fileAtoms";

const deleteFile = async (s3file: S3File) => {
  try {
    await remove({
      path: s3file.path,
    });

    // cocoon → pre-cocoon に置き換えたパスも削除
    if (s3file.path.includes("/cocoon/")) {
      const prePath = s3file.path.replace("/cocoon/", "/pre-cocoon/");
      await remove({ path: prePath });
    }
  } catch (error) {
    console.error(`Error removing the file: ${error}`);
  }
};

export const handleDeleteButtonClick = async (
  filesToDelete: S3File[],
  onReload: (value: (prevKey: number) => number) => void
) => {
  const userConfirmed = window.confirm('Do you really want to delete the selected files?');

  if (!userConfirmed) {
    return;
  }

  try {
    await Promise.all(filesToDelete.map(deleteFile));
    onReload(prevKey => prevKey + 1);
  } catch (error) {
    console.error('Error deleting files:', error);
  }
};
